module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_6-f3492f3d873aafd69b8c1f90e3c1612b.jpg";